import { Injectable } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { NavController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class LangRoutingService {

  constructor(
    private router: Router,
    private navController: NavController,
    private translate: TranslateService
  ) {}

  getCurrentLang(): string {
    const [lang] = this.router.url
      .split('?')[0]
      .split('#')[0]
      .split('/')
      .filter(Boolean);

    return ['id', 'en'].includes(lang) ? lang : 'id';
  }

  applyLang(lang: string) {
    this.translate.setFallbackLang('id');
    return this.translate.use(lang);
  }

  navigate(path: string[], extras?: NavigationExtras) {
    const lang = this.getCurrentLang();
    return this.router.navigate([`/${lang}`, ...path], extras);
  }

  navigateByUrl(url: string, extras?: NavigationExtras) {
    const lang = this.getCurrentLang();

    url = url.startsWith('/') ? url.substring(1) : url;

    return this.router.navigate([`/${lang}/${url}`], extras);
  }

  switchLang(lang: string) {
    const urlTree = this.router.parseUrl(this.router.url);
    const primarySegments = urlTree.root.children['primary']?.segments
      .map((segment) => segment.path) ?? [];
    const hasLangPrefix = ['id', 'en'].includes(primarySegments[0] ?? '');
    const currentUrl = hasLangPrefix
      ? primarySegments.slice(1)
      : primarySegments;
    const queryParams = urlTree.queryParams;

    return this.navController.navigateRoot([`/${lang}`, ...currentUrl], {
      queryParams,
      animated: false,
    });
  }

  // ✅ Build URL only (useful for href)
  buildUrl(path: string[]): string {
    const lang = this.getCurrentLang();
    const normalizedPath = path
      .filter(Boolean)
      .map((segment) => segment.replace(/^\/+|\/+$/g, ''));

    return normalizedPath.length > 0
      ? `/${lang}/${normalizedPath.join('/')}`
      : `/${lang}`;
  }
}
